import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RemoveTeamMemberModal from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/RemoveTeamMember/RemoveTeamMemberModal/RemoveTeamMemberModal';
import CommonButton from 'Components/Common/CommonButton/CommonButton';
import useGetUserPermission from 'hooks/useGetUserPermission';
import { UserRole } from 'api/dtos/user';

type Props = {
    id: string;
    role: UserRole;
};

const RemoveTeamMember = ({ id, role }: Props) => {
    const intl = useIntl();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const { isAdmin, isOwner } = useGetUserPermission();

    const isTargetOwner = role === UserRole.Owner;
    const isTargetAdmin = role === UserRole.Admin;
    const canRemove = (isOwner || isAdmin)
        && !isTargetOwner
        && (!isTargetAdmin || isOwner);

    const onRemoveRequest = () => {
        setConfirmationModalOpen(true);
    };

    const onModalClose = () => {
        setConfirmationModalOpen(false);
    };

    return (
        <>
            <CommonButton
                align="bottom"
                disabled={!canRemove}
                label={intl.formatMessage(messages.removeLabel)}
                kind="ghost"
                iconSize={21}
                onClick={onRemoveRequest}
            />
            <RemoveTeamMemberModal
                id={id}
                confirmationModalOpen={confirmationModalOpen}
                onModalClose={onModalClose}
            />
        </>

    );
};

const messages = defineMessages({
    removeLabel: {
        id: 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.RemoveTeamMember.RemoveTeamMember.removeLabel',
        defaultMessage: 'Usuń z organizacji',
    },
});

export default RemoveTeamMember;
